<ng-container *ngIf="data$ | async as data">
  <div class="courses">
    <div class="container">

      <div *allowRole="['ADMIN']" class="courses-header d-flex align-items-center justify-content-between">

        <div class="course-title d-flex align-items-center">
          <img src="https://d8avu785lzlph.cloudfront.net/images/neo-img/Mask%20group.svg"
            *ngIf="allCoursesList(data)?.length > 0" />
          <h2>{{ 'courses.allCourses' | translate}}</h2>
        </div>

        <div class="courses-header-btns d-flex align-items-center">

          <ng-container *ngIf="allCoursesList(data)?.length > 0">

            <button class="ai-btn-link" (click)="openAiChat(data.allCourses)">
            <span class="material-symbols-outlined">
              auto_fix
            </span>
              <span>Suggest me course titles</span>
            </button>

            <button class="btn-new-course d-flex align-items-center" mat-raised-button
              (click)="addNewCourse(data.allCourses, data.tenant)"
              [ngStyle]="{'background-color': data?.tenant?.brandTheme?.accentColor }">
              <span class="material-symbols-outlined"> add_to_queue </span>
              <span>Create New Course</span>
            </button>

          </ng-container>

        </div>
      </div>

      <ng-container *denyRole="['ADMIN']">

        <div class="courses-header d-flex align-items-center justify-content-between" *ngIf="!showMyCourses(data)">
          <div class="course-title d-flex align-items-center">
            <img src="https://d8avu785lzlph.cloudfront.net/images/neo-img/Mask%20group.svg" />
            <h2> {{ 'courses.allCourses' | translate}} </h2>
          </div>

        </div>

      </ng-container>

      <!-- all courses list -->
      <ng-container *ngIf="showAllCourses(data)">
        <div *ngIf="allCoursesList(data)?.length > 0; else noCourses">
          <courses-list [CourseListbrandAccentColor]="data?.tenant?.brandTheme?.accentColor"
            [CourseListbrandPrimaryColor]="data?.tenant?.brandTheme?.primaryColor" [courses]="allCoursesList(data)"
            (moveDown)="onCourseMovedDown(data.allCourses, $event)" (moveUp)="onCourseMovedUp(data.allCourses, $event)">
          </courses-list>

        </div>
      </ng-container>

      <div class="my-courses" *ngIf="showMyCourses(data)">
        <ng-container *ngIf="data.userCourses?.length > 0">

          <div class="courses-header d-flex align-items-center justify-content-between">
            <div class="course-title d-flex align-items-center">
              <img src="https://d8avu785lzlph.cloudfront.net/images/neo-img/Mask%20group.svg" />
              <h2>{{ 'courses.myCourses' | translate}}</h2>
            </div>
          </div>

          <!-- My Courses list -->
          <courses-list [CourseListbrandAccentColor]="data?.tenant?.brandTheme?.accentColor"
            [CourseListbrandPrimaryColor]="data?.tenant?.brandTheme?.primaryColor" [courses]="data.userCourses">
          </courses-list>

        </ng-container>


        <ng-container *ngIf="availableCourses(data.allCourses,data.userCourses) as unpurchasedCourses">

          <ng-container *ngIf="unpurchasedCourses.length > 0">

            <div class="courses-header d-flex align-items-center justify-content-between">
              <div class="course-title d-flex align-items-center">
                <img src="https://d8avu785lzlph.cloudfront.net/images/neo-img/Mask%20group.svg" />
                <h2>{{ 'courses.getTheseCoursesLifeTimeAccess' | translate}}</h2>
              </div>
            </div>

            <!-- Unpurchased courses list -->
            <courses-list [CourseListbrandAccentColor]="data?.tenant?.brandTheme?.accentColor"
              [CourseListbrandPrimaryColor]="data?.tenant?.brandTheme?.primaryColor" [courses]="unpurchasedCourses">
            </courses-list>

          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <page-footer></page-footer>

  <ng-template #noCourses>
    <div class="no-content no-courses mat-elevation-z2" *denyRole="['ADMIN']">
      <span>{{ "courses.noCoursesAvailableYet" | translate }}</span>
    </div>

    <div class="course-empty-content" *allowRole="['ADMIN']">

      <img class="course-empty-img" [src]="nocoursesimgurl" alt="no-courses-image">

      <span class="course-empty-title">No courses yet, let's create one!</span>

      <span class="course-empty-desc">Follow our simplified course creation procedure, and get your first course up and
        running in minutes. No design or technical skills are needed.</span>

      <a class="course-empty-btn-new-course" (click)="addNewCourse(data.allCourses, data.tenant)"
        [ngStyle]="{'background-color': data?.tenant?.brandTheme?.accentColor }">
        <span class="material-symbols-outlined new-course-btn-icon"> add_to_queue </span>
        <span class="new-course-btn-text">Create New Course</span>
      </a>


      <button class="ai-btn-link" (click)="openAiChat(data.allCourses)">
        <span class="material-symbols-outlined">
          auto_fix
        </span>
        <span>Suggest me course titles</span>
      </button>
    </div>
  </ng-template>

  <ng-container *ngIf="questionaireVisible(data)">
      <questionnaire></questionnaire>
  </ng-container>

</ng-container>
